// extracted by mini-css-extract-plugin
module.exports =  {"link":"VQQuFMqy96UPnnQIKDUZ"};